var _circle, _path, _circle2, _circle3, _g, _rect, _rect2, _rect3, _path2, _ellipse, _rect4, _path3, _path4, _path5, _path6, _g2, _path7, _ellipse2, _g3, _path8, _ellipse3, _g4, _path9, _ellipse4, _g5, _path10, _ellipse5, _g6, _path11, _ellipse6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 265,
    r: 264.5,
    stroke: "#0087FF",
    strokeOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529 265C529 230.331 522.171 196.002 508.904 163.972C495.637 131.942 476.191 102.838 451.676 78.3238C427.162 53.8091 398.058 34.363 366.028 21.0958C333.998 7.82856 299.669 0.999998 265 1V265L529 265Z",
    fill: "url(#paint0_linear_1351_27464)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 265,
    r: 189.5,
    stroke: "#0087FF",
    strokeOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 268,
    r: 124.5,
    stroke: "#0087FF",
    strokeOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213 200.176C213 198.614 214.261 197.347 215.822 197.339L279.81 197.006C280.571 197.002 281.302 197.304 281.838 197.845L314.177 230.435C314.704 230.967 315 231.685 315 232.434V330.163C315 331.73 313.73 333 312.163 333H215.837C214.27 333 213 331.73 213 330.163V200.176Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224.333,
    y: 236.917,
    width: 44.625,
    height: 5.65195,
    rx: 2.82597,
    fill: "#C6DFF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224.333,
    y: 219.961,
    width: 24.0833,
    height: 5.65195,
    rx: 2.82597,
    fill: "#C6DFF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.333,
    y: 253.873,
    width: 39.6667,
    height: 5.65195,
    rx: 2.82597,
    fill: "#C6DFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.977 287.014C258.977 295.172 247.195 314.631 244.167 314.631C241.138 314.631 229.356 295.172 229.356 287.014C229.356 278.855 235.987 272.242 244.167 272.242C252.346 272.242 258.977 278.855 258.977 287.014Z",
    fill: "#FEB43C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.166,
    cy: 286.371,
    rx: 6.43939,
    ry: 6.42267,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 312.875,
    y: 253.167,
    width: 2.125,
    height: 48.7481,
    fill: "#ABCDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M325.487 260.708L329.358 265.177L288.792 306.86L282.55 303.534L325.487 260.708Z",
    fill: "#0087FF",
    fillOpacity: 0.31
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311.813 249.281L319.17 253.855L324.878 259.549L281.664 302.65L275.956 296.957L271.792 288.138L311.813 249.281Z",
    fill: "#45A8FF",
    fillOpacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 299.795L332 308.273M332 308.273L334.479 305.8L349 318.164L342.271 325.582L329.167 311.099L332 308.273Z",
    stroke: "#2F3139",
    strokeWidth: 2.83701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.871 277.894C329.871 293.878 316.878 306.849 300.833 306.849C284.789 306.849 271.796 293.878 271.796 277.894C271.796 261.909 284.789 248.939 300.833 248.939C316.878 248.939 329.871 261.909 329.871 277.894Z",
    stroke: "#0087FF",
    strokeWidth: 5.67403
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 403,
    r: 28,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.475 400.131C402.475 404.829 395.691 416.034 393.947 416.034C392.203 416.034 385.418 404.829 385.418 400.131C385.418 395.433 389.237 391.625 393.947 391.625C398.657 391.625 402.475 395.433 402.475 400.131Z",
    fill: "#B29DEC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.947,
    cy: 399.761,
    rx: 3.70798,
    ry: 3.69835,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 383,
    r: 40,
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.107 378.902C124.107 385.613 114.415 401.62 111.924 401.62C109.433 401.62 99.7407 385.613 99.7407 378.902C99.7407 372.191 105.195 366.75 111.924 366.75C118.653 366.75 124.107 372.191 124.107 378.902Z",
    fill: "#7DBEF8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.924,
    cy: 378.373,
    rx: 5.29711,
    ry: 5.28335,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 221.5,
    r: 22.5,
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M450.445 218.178C450.445 222.398 444.351 232.462 442.785 232.462C441.219 232.462 435.125 222.398 435.125 218.178C435.125 213.959 438.554 210.539 442.785 210.539C447.015 210.539 450.445 213.959 450.445 218.178Z",
    fill: "#FF8762"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.785,
    cy: 217.846,
    rx: 3.33033,
    ry: 3.32168,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 222.5,
    r: 19.5,
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2769 219.621C85.2769 223.278 79.9957 232 78.6385 232C77.2812 232 72 223.278 72 219.621C72 215.964 74.9721 213 78.6385 213C82.3048 213 85.2769 215.964 85.2769 219.621Z",
    fill: "#75CFA9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.6382,
    cy: 219.333,
    rx: 2.88628,
    ry: 2.87879,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1351_27464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 79.5,
    r: 23.5,
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M271.462 76.0307C271.462 80.4376 265.097 90.9487 263.462 90.9487C261.826 90.9487 255.461 80.4376 255.461 76.0307C255.461 71.6238 259.043 68.0513 263.462 68.0513C267.88 68.0513 271.462 71.6238 271.462 76.0307Z",
    fill: "#FFD12E"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.462,
    cy: 75.6837,
    rx: 3.47834,
    ry: 3.46931,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1351_27464",
    x: 190.304,
    y: 177.147,
    width: 147.392,
    height: 181.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.83701
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3481
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1351_27464",
    x: 344.639,
    y: 356.309,
    width: 98.7221,
    height: 98.7221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1351_27464",
    x: 50.639,
    y: 324.309,
    width: 122.722,
    height: 122.722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1351_27464",
    x: 398.639,
    y: 180.309,
    width: 87.7221,
    height: 87.7221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1351_27464",
    x: 38.639,
    y: 184.309,
    width: 81.7221,
    height: 81.7221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1351_27464",
    x: 219.639,
    y: 37.3091,
    width: 89.7221,
    height: 89.7221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_27464",
    x1: 265,
    y1: 1,
    x2: 439.768,
    y2: 167.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0087FF",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.21e729e7f6a28042624019d140567b4d.svg";
export { ForwardRef as ReactComponent };